import { useCallback, useEffect, useRef, useState } from 'react';
import { ChannelTalk } from '@encarpkg/shared';
import { getChannelTalkUserkey, postChannelTalkUserkey, postChannelTalkUser } from '@encarpkg/api';
import { loggingException } from 'app/libs/sentry';

export default function useHsChannelTalk({ disabled = false, applicationUuid }) {
	const channelTalk = ChannelTalk();
	const canProceed = useRef(true);
	const isBootCompleted = useRef(false);
	const [isAlertModalOpen, setIsAlertModalOpen] = useState(false);

	const updateChannelTalkUserInfo = useCallback((key) => {
		postChannelTalkUser({ key }).catch(loggingException);
	}, []);

	const channelTalkBoot = useCallback(
		(userKey) => {
			const option = {
				pluginKey: '56afd69b-0183-465c-99ae-a64a56dc562f',
				memberId: userKey,
				hideChannelButtonOnBoot: true,
				hidePopup: true,
			};
			channelTalk.boot(option, (error) => {
				if (error) {
					// 에러시 한 번 더 boot 시도
					channelTalk.boot(option, (e) => {
						if (e) return;
						updateChannelTalkUserInfo(userKey);
						isBootCompleted.current = true;
					});
					return;
				}
				updateChannelTalkUserInfo(userKey);
				isBootCompleted.current = true;
			});
		},
		[channelTalk, updateChannelTalkUserInfo],
	);

	const channelTalkInit = useCallback(() => {
		(async () => {
			if (!canProceed.current) return;
			if (!applicationUuid) return;
			try {
				canProceed.current = false;

				// 채널톡 key 조회
				const { data } = await getChannelTalkUserkey({
					externalKey: applicationUuid,
					serviceName: 'homeservice',
				});
				channelTalkBoot(data.channelTalk.key);
			} catch (error) {
				// 발급된 채널톡 key 없음
				if (error.response?.data?.errorCode === '3200') {
					try {
						const { data } = await postChannelTalkUserkey({
							externalKey: applicationUuid,
							serviceName: 'homeservice',
						});
						channelTalkBoot(data.channelTalkActive);
						return;
					} catch (e) {
						console.error(e);
						loggingException(e);
						return;
					}
				}
				console.error(error);
				loggingException(error);
			}
		})();
	}, [applicationUuid, channelTalkBoot]);

	useEffect(() => {
		if (disabled) return;
		channelTalkInit();
	}, [channelTalkInit, disabled]);

	// 채널톡 채팅방 open
	const openChannelTalk = () => {
		if (!isBootCompleted.current) {
			setIsAlertModalOpen(true);
			return;
		}
		channelTalk.openMessanger();
	};

	return {
		isAlertModalOpen,
		setIsAlertModalOpen,
		openChannelTalk,
	};
}
